export default __webpack_public_path__ + "static/media/050_brake.last.bf7098f5.webp";